import * as React from "react";
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';

export const AddContractTemplateButton = ({ record }) => (
    <Button
        component={Link}
        to={{
            pathname: '/contract-templates/create',
            state: { record: { production_id: record && record.id } },
        }}
        startIcon={<AddIcon />}
    >
        Add Contract Template
    </Button>
);
